import { render, staticRenderFns } from "./PrintBody.vue?vue&type=template&id=3096be90&scoped=true&"
import script from "./PrintBody.vue?vue&type=script&lang=ts&"
export * from "./PrintBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096be90",
  null
  
)

export default component.exports